import { render } from "./Spinner.vue?vue&type=template&id=3b7eac5e&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=3b7eac5e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/proship-public-order/proship-public-order/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7eac5e"]])

export default __exports__